import { resetMovetoStore } from '../actions/internalActions';
import { getStore, initialStore } from '../store/store';
import { mutator } from 'satcheljs';

// reset moveTo mailbox store to its initial value
mutator(resetMovetoStore, () => {
    let moveToStore = getStore();
    Object.keys(moveToStore).forEach(prop => {
        moveToStore[prop] = initialStore[prop];
    });
});
